import React from "react";
import ContentWrapper from "@/presentation/components/content-wrapper";
import ContentFormLayoutWrapper from "@/presentation/components/content-wrapper/content-form-layout-wrapper";
import SettingsOrganizationPolicyFunctionsEdit from "@/presentation/pages/settings/orgnanization-policy-functions/settings-organization-policy-functions-edit";
import { Header } from "@cloudscape-design/components-themed/components";
const SettingsOrganizationPolicyFunctionsFormWrapper = () => {
    return React.createElement(ContentWrapper, { testid: "settings-organization-policy-functions-edit-page" },
        React.createElement(ContentFormLayoutWrapper, { header: React.createElement(Header, { variant: "h1" }, "Edit Organization Policy Functions") },
            React.createElement(SettingsOrganizationPolicyFunctionsEdit, null)));
};
export default SettingsOrganizationPolicyFunctionsFormWrapper;
